import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagCloud from '../TagCloud/TagCloud';

export default class CampaignForm extends Component {
  state = {
    showErrors: false,
    errors: {},
    name: this.props.campaign?.name || '',
    description: this.props.campaign?.description || '',
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showErrors } = this.state;

    if (showErrors) {
      this.validate(nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    const { campaign } = this.props;

    if (campaign && campaign !== prevProps.campaign) {
      this.setState({
        name: campaign.name || '',
        description: campaign.description || '',
      });
    }
  }

  onChange = event => {
    const { onChange } = this.props;

    onChange(event.target.name, event.target.value);
  };

  onChangeTag = tags => {
    const { onChange } = this.props;

    onChange('tags', tags);
  };

  onChangeCommander = () => {
    const {
      campaign: { commander_enabled },
      onChange,
    } = this.props;

    onChange('commander_enabled', !commander_enabled);
  };

  errorClass = error => (error ? 'error' : null);

  validate = nextProps => {
    const props = nextProps || this.props;
    const {
      campaign: { name },
    } = props;
    const errors = {};

    if (!name || !name.trim()) {
      errors.name = 'This field cannot be empty.';
    } else if (!this.isUniqueName(props)) {
      errors.name = 'This name is already in use.';
    }

    this.setState({ showErrors: true, errors });

    return !errors.name;
  };

  submit = event => {
    const { isNew, onAdd, onUpdate } = this.props;

    event.preventDefault();

    if (!this.validate()) {
      return;
    }

    if (isNew) {
      onAdd();
    } else {
      onUpdate();
    }
  };

  isUniqueName = props => {
    const { campaigns, campaign } = props;
    const name = campaign.name.toLowerCase().trim();

    return !campaigns.some(item => {
      const itemName = item.name.toLowerCase().trim();

      return +item.id !== +campaign.id && itemName === name;
    });
  };

  getButtons = () => {
    const {
      auth: {
        user: {
          permissions: { Writer },
        },
      },
      isNew,
      onCancel,
    } = this.props;
    const add = (
      <button
        className="flex-1 bg-btn-primary-form text-white px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/20"
        key="1"
        data-test="button-add"
        type="submit"
      >
        Add Campaign
      </button>
    );
    const update = (
      <button
        className="flex-1 bg-btn-primary-form text-white px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/20"
        key="2"
        data-test="button-update"
        type="submit"
      >
        Save Changes
      </button>
    );
    const cancel = (
      <button
        type="button"
        className="px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs text-gray-400 hover:text-black transition-colors border border-transparent hover:border-gray-200"
        key="3"
        data-test="button-cancel"
        onClick={onCancel}
      >
        Cancel
      </button>
    );

    if (!Writer) {
      return [cancel];
    }

    return isNew ? [add, cancel] : [update, cancel];
  };

  render() {
    const {
      auth: {
        user: {
          commander_enabled,
          permissions: { Writer, Deployer },
        },
      },
      campaign,
    } = this.props;
    const { name, description, errors } = this.state;

    if (!campaign) {
      return null;
    }

    const { tags } = campaign;

    return (
      <div
        id="edit"
        className="form-signs lg:col-span-8 mt-8 bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-200 p-4"
      >
        <form className="space-y-6" onSubmit={this.submit}>
          <div className="relative group">
            {this.errorClass(errors.name) && (
              <span className="text-sunrise mt-1 mb-1">{errors.name}</span>
            )}
            <label
              htmlFor="campaign-input-name"
              className=" form-label text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
            >
              Name
            </label>
            <input
              id="campaign-input-name"
              data-test="input-name"
              type="text"
              name="name"
              value={name}
              onChange={e => this.setState({ name: e.target.value })}
              onBlur={e => this.onChange(e)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.stopPropagation();
                  this.onChange(e);
                }
              }}
              disabled={!Writer}
              className="w-full text-xl font-bold px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none"
            />
          </div>
          <div className="relative group">
            <label
              htmlFor="campaign-description"
              className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
            >
              Description
            </label>
            <textarea
              id="campaign-description"
              data-test="input-desc"
              rows="1"
              onInput={e => {
                e.target.style.height = 'auto';
                e.target.style.height = `${e.target.scrollHeight}px`;
              }}
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
              onBlur={e => this.onChange(e)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.stopPropagation();
                  this.onChange(e);
                }
              }}
              disabled={!Writer}
              name="description"
              className="w-full text-xl font-medium px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none resize-none"
            />
          </div>
          <TagCloud tags={tags} onChange={this.onChangeTag} disabled={!Writer} />
          {Boolean(commander_enabled) && (
            <div className="flex items-center">
              <input
                data-test="checkbox-commander"
                id="commander-enabled-checkbox"
                type="checkbox"
                name="commander_enabled"
                placeholder="Enter description"
                checked={campaign.commander_enabled}
                onChange={this.onChangeCommander}
                disabled={!Deployer}
              />
              <label htmlFor="commander-enabled-checkbox">Commander enabled</label>
            </div>
          )}

          {/* <Metadata data={campaign} users={users} /> */}
          <div data-test="form-buttons" className="pt-6 flex flex-col sm:flex-row gap-4">
            {this.getButtons()}
          </div>
        </form>
      </div>
    );
  }
}

CampaignForm.propTypes = {
  auth: PropTypes.object.isRequired,
  campaigns: PropTypes.array,
  campaign: PropTypes.object,
  isNew: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
